import { orpcClient } from "@/frontend/orpc-client";

/** Search param that switches the active workspace on whatever page it appears on. */
const ORG_ID_PARAM = "orgId";

/** Whether the current URL carries a workspace-switch deep link. */
export function hasActiveWorkspaceParam(): boolean {
  return new URLSearchParams(window.location.search).has(ORG_ID_PARAM);
}

/**
 * Applies an inbound `?orgId=` deep link to the session, then strips it from the
 * URL. It runs before the first render, so the opening paint already reads the
 * workspace that was asked for and no component has to notice the switch. A
 * workspace the caller does not belong to is refused server-side, and the param
 * is dropped either way so a reload cannot replay it.
 */
export async function applyActiveWorkspaceParam(): Promise<void> {
  const params = new URLSearchParams(window.location.search);
  const organizationId = params.get(ORG_ID_PARAM);
  if (!organizationId) return;

  try {
    await orpcClient.org.setActiveOrganization({ organizationId });
  } catch {
    // Not a member, or no orgMember session yet. Drop the param and carry on.
  }

  params.delete(ORG_ID_PARAM);
  const query = params.toString();
  const nextUrl = `${window.location.pathname}${query ? `?${query}` : ""}${window.location.hash}`;
  window.history.replaceState({}, "", nextUrl);
}
